import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { healthTopics } from '../../data/homeContent';
export function HealthSection() {
  return <section aria-labelledby="sante-title" className="bg-ink text-paper" data-id="element-15" data-mp="2w66v4xtlbrhd">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-16" data-mp="2w43wjpedgq11">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-17" data-mp="30y81y47zoq00">
          <div className="lg:col-span-6" data-id="element-18" data-mp="35w9mktl2cxdl">
            <p className="text-sm font-medium text-[#D9A27C]" data-id="element-19" data-mp="35v896igkrysp">Performance & santé du musicien</p>
            <h2 id="sante-title" className="mt-4 font-display text-4xl font-medium leading-tight md:text-6xl" data-id="element-20" data-mp="3at9rh166fu34">
              Jouer longtemps,
              <br data-id="element-21" data-mp="3jviznkdz3bdc" />
              <em className="font-normal italic" data-id="element-22" data-mp="3jw14h5epaxwv">jouer sans douleur.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:self-end" data-id="element-23" data-mp="1kj6v90z5v00u">
            <p className="leading-relaxed text-paper/75" data-id="element-24" data-mp="1phi69f16zgkn">
              Des consultations individuelles pour tous les musiciens — pas seulement les violoncellistes.
              Un regard extérieur sur votre posture, votre préparation et votre façon de travailler.
            </p>
            <Link to="/sante-du-musicien" className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-paper px-6 py-3 text-sm font-medium text-ink transition-colors duration-150 hover:bg-paper-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-paper focus-visible:ring-offset-4 focus-visible:ring-offset-ink" data-id="element-25" data-mp="1jvmx9xumatmn">
              Prendre rendez-vous
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-26" data-mp="1ymdop4sarqp8" />
            </Link>
          </div>
        </div>

        <ul className="mt-20 grid gap-x-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="1toc3oebb9hb4">
          {healthTopics.map(topic => <li key={topic.title} className="border-t border-line-dark py-7" data-id="element-28" data-mp="n89ubxhss0jn">
              <h3 className="font-display text-2xl font-medium" data-id="element-29" data-mp="i849p19y3eb2">{topic.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-paper/65" data-id="element-30" data-mp="jpsyvat3yux7">{topic.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}